import { useSelector } from "react-redux"; // To access the token from Redux store
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import axios from "axios";
import "./App.css";

import { Provider } from "react-redux";
import store from "./store";

// Pages
import Home from "./pages/home";
import Login from "./pages/login";
import Register from "./pages/register";
import UserProfile from "./pages/userProfile";
import AddBand from "./pages/addBand";
import EditBand from "./pages/editBand";
import BandPage from "./pages/bandPage";
import BlogPage from "./pages/blogPage";
import AddAndEditPost from "./pages/addAndEditPost";
import AddAndEditEvent from "./pages/addAndEditEvent";
import AddAndEditOrganizer from "./pages/addAndEditOrganizer";
import PageNotFound from "./pages/pageNotFound";
import NewsPage from "./pages/newsPage";
import BlogsPage from "./pages/blogsPage";
import DiscoverPage from "./pages/discoverPage";
import SearchPage from "./pages/searchPage";
import AboutPage from "./pages/aboutPage";
import AdsAboutPage from "./pages/adsAboutPage";
import VerifyMailPage from "./pages/verifyMailPage";
import EditProfilePage from "./pages/editProfilePage";
import ForgotPasswordPage from "./pages/forgotPasswordPage";
import ContactPage from "./pages/contactPage";
import LokultNewsPage from "./pages/lokultNewsPage";
import Playlist from "./pages/playlist";
import TermsPage from "./pages/termsPage";
import GdprPage from "./pages/gdprPage";
import EventsPage from "./pages/eventsPage";
import EventPage from "./pages/eventPage";
import OrgPage from "./pages/orgPage";

function App() {
  return (
    <Provider store={store}>
      <AppWithRoutes />
    </Provider>
  );
}

function AppWithRoutes() {
  const token = useSelector((state) => state.token); // Access token from Redux store

  useEffect(() => {
    // Fetch the CSRF token once on startup. The backend returns it in the
    // response body so we can set it as a default header — this works
    // regardless of cross-origin cookie restrictions in production.
    axios.get(`${import.meta.env.VITE_API_URL}csrf`).then((res) => {
      axios.defaults.headers.common["X-CSRFToken"] = res.data.csrfToken;
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home token={token} />} />
        <Route
          path="/login"
          element={token ? <Navigate to="/userprofile" /> : <Login />}
        />
        <Route
          path="/register"
          element={token ? <Navigate to="/userprofile" /> : <Register />}
        />
        <Route
          path="/userprofile"
          element={token ? <UserProfile /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/addmusicproject"
          element={token ? <AddBand /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/band"
          element={token ? <EditBand /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/editpost"
          element={token ? <AddAndEditPost /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/addpost"
          element={token ? <AddAndEditPost /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/addevent"
          element={token ? <AddAndEditEvent /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/editevent"
          element={token ? <AddAndEditEvent /> : <Navigate to="/404" />}
        />
        <Route
          path="/userprofile/editorganizer"
          element={token ? <AddAndEditOrganizer /> : <Navigate to="/404" />}
        />
        <Route path="/music/:bandslug" element={<BandPage token={token} />} />
        <Route
          path="/music/:bandslug/blog/:postSlugId"
          element={<BlogPage token={token} />}
        />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/partnership" element={<AdsAboutPage />} />
        <Route path="/verifyme" element={<VerifyMailPage />} />
        <Route
          path="/userprofile/editprofile"
          element={token ? <EditProfilePage /> : <Navigate to="/" />}
        />
        <Route
          path="/forgotpassword"
          element={token ? <Navigate to="/" /> : <ForgotPasswordPage />}
        />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/gdpr" element={<GdprPage />} />
        <Route path="/lokult-news" element={<LokultNewsPage />} />
        <Route path="/playlist" element={<Playlist />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:eventSlug" element={<EventPage />} />
        <Route path="/orgs/:slug" element={<OrgPage />} />
        <Route path="/404" element={<PageNotFound />} />
        <Route path="*" element={<Navigate to="/404" />} />
      </Routes>
    </Router>
  );
}

export default App;
